
// @ts-nocheck
import { defineComponent, reactive, toRefs } from 'vue'
import rem from '@/utils/rem.js'
import request from '@/utils/hbRequest.js'
import { useRoute, useRouter } from 'vue-router'
import { Toast } from 'vant'

rem(750, 750)

export default defineComponent({
  name: 'ServiceList',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const state = reactive({
      list: [],
      activityId: null, // 活动id
      activityName: null,
      salesmanId: null // 业务员id
    })

    state.salesmanId = route.query.salesmanId
    state.activityId = route.query.activityId

    const getList = async () => {
      const res = await request.get(
        `/spread/activity/${state.activityId}/detail`
      )
      if (res.code !== 0) {
        return Toast(res.message)
      }
      state.activityId = res.data.activityId
      state.activityName = res.data.activityName
      state.list = res.data.servingList
      save()
    }

    // 浏览记录
    const save = () => {
      const oScript = document.createElement('script')
      oScript.type = 'text/javascript'
      oScript.src = 'https://pv.sohu.com/cityjson?ie=utf-8'
      document.body.appendChild(oScript)
      setTimeout(() => {
        const params = {
          activityId: state.activityId,
          salesmanId: state.salesmanId,
          pageUrl: '/huBeiService/serviceList',
          ip: window.returnCitySN ? window.returnCitySN.cip : ''
        }
        request.post('/spread/visit/record/save', params)
      }, 1000)
    }

    getList()

    const toDetail = (item) => {
      const params = {
        activityId: state.activityId,
        activityName: state.activityName,
        salesmanId: state.salesmanId,
        servingId: item.servingId,
        price: item.price,
        fileList: item.fileList,
        externalUrl: item.externalUrl
      }
      sessionStorage.setItem('routerParams', JSON.stringify(params))
      if (item.externalUrl) {
        router.push({ name: 'ServiceTempDetail' })
      } else {
        router.push({ name: 'ServiceDetail' })
      }
    }

    return {
      ...toRefs(state),
      toDetail
    }
  }
})
